import { Navigate } from 'react-router-dom';

import {
  hasAcceptedAuthTermsGate,
  hasOnboardingDraftSession,
} from '@/domains/identity/auth/lib/termsGate';

interface TermsRouteProps {
  children: React.ReactNode;
}

export function TermsRoute({ children }: TermsRouteProps) {
  const canAccessRegister = hasAcceptedAuthTermsGate() || hasOnboardingDraftSession();

  if (!canAccessRegister) {
    return <Navigate to="/terms-gate?flow=register" replace />;
  }

  return <>{children}</>;
}
